export default __webpack_public_path__ + "static/media/anders.b3068310.jpg";